import { extractBlankValues } from './extractBlankValues';

import { splitPromptForFillInBlank } from '../../Shared/libs/splitPromptForFillInBlank';

interface CueTemplate {
  conceptResults: any[];
  cue: string;
  feedback: string;
  optimal: boolean;
}

interface BlankByBlankGrading {
  [key: string]: CueTemplate[]; // blank1, blank2, etc.
}

interface Response {
  text: string;
  [key: string]: any;
}

interface Question {
  blankByBlankGrading?: BlankByBlankGrading;
  caseInsensitive?: boolean;
  prompt: string;
  [key: string]: any;
}

export function calculateBlankPassingRates(
  responses: Response[],
  question: Question
): number[] {
  if (!responses || responses.length === 0 || !question || !question.prompt) {
    return [];
  }

  const promptParts = splitPromptForFillInBlank(question.prompt);
  const numberOfBlanks = promptParts.length - 1;

  if (numberOfBlanks === 0) {
    return [];
  }

  if (!question.blankByBlankGrading) {
    return new Array(numberOfBlanks).fill(0);
  }

  const caseInsensitive = question.caseInsensitive || false;

  const passingCounts = new Array(numberOfBlanks).fill(0);

  responses.forEach(response => {
    const blankValues = extractBlankValues(response.text, question.prompt);

    blankValues.forEach((value, blankIndex) => {
      const blankKey = `blank${blankIndex + 1}`;
      const cueTemplates = question.blankByBlankGrading![blankKey];

      if (!cueTemplates) {
        return;
      }

      const normalizedValue = caseInsensitive ? value.toLowerCase() : value;

      const isOptimal = cueTemplates.some(template => {
        if (!template.optimal) {
          return false;
        }

        const normalizedCue = caseInsensitive
          ? template.cue.toLowerCase()
          : template.cue;

        return normalizedCue === normalizedValue;
      });

      if (isOptimal) {
        passingCounts[blankIndex] += response.count;
      }
    });
  });

  return passingCounts.map(count => {
    const percentage = ((count / responses.reduce((sum, response) => sum + response.count, 0)) * 100);
    return Math.round(percentage * 10) / 10;
  });
}
